export const emirates = [
    {value: "Abu Dhabi", label: "Abu Dhabi"},
    {value: "Dubai", label: "Dubai"},
    {value: "Sharjah", label: "Sharjah"},
    {value: "Ajman", label: "Ajman"},
    {value: "Umm Al-Quwain", label: "Umm Al-Quwain"},
    {value: "Fujairah", label: "Fujairah"},
    {value: "Raʾs al-khaimah", label:"Raʾs al-khaimah"}
];